import React, { Component } from 'react';
import './radiolist.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
//import { layer } from '@fortawesome/fontawesome-svg-core';



class RadioList extends Component {
    constructor(props) {
      super(props);
      // PROPS
      /*
        --config={color:"#aad",name:"",options:[
            {name:"Choice 1",value:"1",isEnabled:true, isSelected:true},
            {name:"Choice 2",value:"2",isEnabled:false, isSelected:false}
          ]}
          //  color = hexa color for CSS text
          //  name
          //  value
          //  isEnabled
          //  isSelected
        --updateValue  //callbackMethod
      */
        this.state = {
            activeId:null,
        };

  }

  // INNER METHOD
  toggleBox = (e) =>{
    console.log("params",e);
    this.setState({activeId:e});
    this.props.updateChange(e);
  }

  // BUILDING METHOD
  buildList = () =>{
    var radioList = null;
    var radioGroup = this.props.config.name;
    var activeRadioId = this.state.activeId !== null?this.state.activeId:this.props.config.options.findIndex(item=>item.isSelected);
    radioList = this.props.config.options.map((item,i)=>{
      if(item.isEnabled){
        return <div className={activeRadioId ===i?"radioItemWrapper active":"radioItemWrapper"} key={i} onClick={this.toggleBox.bind(this,i)}>
        <div className="inputWrapper"><input type="radio" id={i} name={radioGroup} value={item.value}
          checked={activeRadioId ===i?true:false}  onChange={this.toggleBox.bind(this,i)}/></div>
          <span>{item.name}</span>
        </div>
      }else{
        return <div className="radioItemWrapper disabled" key={i}>
          <div className="inputWrapper"><FontAwesomeIcon icon="ban"/></div>
          <span>{item.name}</span>
        </div>
      }
      

    });

    return radioList
  }
  
  
  // ---------------------RENDER --------------------- 
  render() {
    var labelStyle = {color: this.props.config.color,background: this.props.config.background};
    var radioList = this.buildList();

      return (
          <div className={"radioListWrapper"} style={labelStyle}>
            <div className="header">
              {this.props.config.name}
            </div>
            <div className="list">
              {radioList}
            </div>
          </div>
      );
  }
}
  
const mapStateToProps = (state) => {    
  return {  
    
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(RadioList);
  